<script lang="ts">
import { loadWorkspacePage } from '@/dashboard/utils/workspace/loadWorkspacePage';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

export default {
  beforeRouteEnter: async function (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
    next();
    const shortLink = (to.params as { short_link: string }).short_link;
    await loadWorkspacePage(shortLink);
  },
  beforeRouteUpdate: async function (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
    next();
    const shortLink = (to.params as { short_link: string }).short_link;
    await loadWorkspacePage(shortLink);
  },
};
</script>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useAppStore } from '@/dashboard/store/appStore';
import WorkspaceTeamSection from '@/dashboard/vue/components/workspace/WorkspaceTeamSection/WorkspaceTeamSection.vue';
import WorkspaceDirectoriesSection from '@/dashboard/vue/components/workspace/WorkspaceDirectoriesSection.vue';
import WorkspaceWatermarkSection from '@/dashboard/vue/components/workspace/WorkspaceWatermarkSection.vue';
import WorkspaceTitlePanel from '@/dashboard/vue/components/workspace/WorkspaceTitlePanel/WorkspaceTitlePanel.vue';
import PaymentPopup from '@/dashboard/vue/popups/PaymentPopup.vue';
import LoaderIcon from '@/dashboard/vue/components/icons/LoaderIcon.vue';
import { useWorkspaceStore } from '@/dashboard/store/workspaceStore';

const appStore = useAppStore();
const workspaceStore = useWorkspaceStore();

const { workspace, currentWorkspaceUser } = storeToRefs(appStore);
const { pageLoader } = storeToRefs(workspaceStore);
</script>

<template>
  <main class="flex flex-1">
    <div class="flex flex-1 flex-col pt-[56px] laptop:pt-[63px]">
      <div v-if="pageLoader" class="flex flex-1 items-center justify-center">
        <LoaderIcon class="animate-spin stroke-black dark:stroke-white" />
      </div>

      <div v-else class="flex flex-col">
        <WorkspaceTitlePanel />

        <div class="grid flex-wrap gap-s px-s pb-xxl pt-s laptop:px-l laptop:pt-l desktop:grid-cols-[1021px_1fr]">
          <WorkspaceTeamSection v-if="!!workspace && !!currentWorkspaceUser" :workspace="workspace" :workspace-user="currentWorkspaceUser" />
          <WorkspaceDirectoriesSection v-if="false" :workspace="workspace" :workspace-user="currentWorkspaceUser" />
          <WorkspaceWatermarkSection v-if="false" />
        </div>
      </div>
    </div>
  </main>

  <PaymentPopup />
</template>
